import { LobbyImage } from '@colonist/types';
import { createDivIn, createSpanIn, createImgIn, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { getLobbyImagePath } from '../../../../shared/scripts/ui_utils/Utils.ts';
export class UIMRoomEditableCard {
    update(title, image, isViewOnly, displayInfoAction) {
        this.isViewOnly = isViewOnly;
        this.titleContainer.innerText = title;
        this.imageContainer.src = getLobbyImagePath(image);
        this.displayInfoAction = displayInfoAction;
        this.applyCardState();
    }
    applyCardState() {
        const shouldShowInfoIcon = this.isViewOnly && this.displayInfoAction != undefined;
        if (this.isViewOnly) {
            this.cardContainer.classList.remove('m-room-settings-card-container-min-selected');
            this.pencilImg.classList.add('hidden');
        } else {
            this.cardContainer.classList.add('m-room-settings-card-container-min-selected');
            this.pencilImg.classList.remove('hidden');
        }
        this.infoImg.classList.toggle('hidden', !shouldShowInfoIcon);
    }
    hide() {
        this.cardContainer.hidden = true;
    }
    show() {
        this.cardContainer.hidden = false;
    }
    constructor(container, title, image, onClick, isViewOnly, displayInfoAction){
        this.isViewOnly = isViewOnly;
        this.displayInfoAction = displayInfoAction;
        this.cardContainer = createDivIn(container, 'm-room-settings-card-container-min m-room-settings-card-container-min-selected');
        const cardHeaderContainer = createDivIn(this.cardContainer, 'm-room-settings-card-header-container');
        const titleContainer = createDivIn(cardHeaderContainer, 'm-room-settings-card-title');
        this.titleContainer = createSpanIn(titleContainer, 'm-room-settings-card-title', title);
        this.imageContainer = createImgIn(cardHeaderContainer, image, 'm-room-settings-card-icon');
        this.pencilImg = createImgIn(cardHeaderContainer, LobbyImage.Pencil);
        this.infoImg = createImgIn(cardHeaderContainer, LobbyImage.InfoIcon);
        this.applyCardState();
        setElementOnClick(this.cardContainer, ()=>{
            if (this.isViewOnly) {
                if (this.displayInfoAction != undefined) this.displayInfoAction();
                return;
            }
            onClick();
        });
    }
}
